import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Title = styled.h1`
  line-height: 0.8;
  text-transform: uppercase;
  font-size: 8rem;
  margin: 0;
  small {
    display: block;
    letter-spacing: 1px;
    &.pretitle {
      margin-bottom: 0.6rem;
      font-size: 2rem;
      line-height: 1.1;
      font-weight: normal;
      font-family: 'Futura', sans-serif;
      letter-spacing: 0.2rem;
    }
    &.posttitle {
      color: #1f4224;
      font-size: 4rem;
      font-size: clamp(
        4rem,
        2.1818181818181817rem + 7.2727272727272725vw,
        8rem
      );
      line-height: 0.9;
      font-weight: normal;
      font-family: 'Akkordeon', sans-serif;

      &.longer {
        font-size: 4rem;
        font-size: clamp(
          4rem,
          2.1818181818181817rem + 7.2727272727272725vw,
          8rem
        );
      }
      &.long {
        font-size: 5.2rem;
        font-size: clamp(
          5.2rem,
          3.9272727272727277rem + 5.09090909090909vw,
          8rem
        );
      }
      &.medium {
        font-size: 6rem;
        font-size: clamp(
          6rem,
          5.090909090909091rem + 3.6363636363636362vw,
          8rem
        );
      }
      &.short {
        font-size: 7rem;
        font-size: clamp(
          7rem,
          6.545454545454546rem + 1.8181818181818181vw,
          8rem
        );
      }
    }
  }
  @media (orientation: portrait) {
    font-size: 6rem;
    small {
      &.pretitle {
        font-size: 1.6rem;
      }
      &.posttitle {
        font-size: 3.5rem;
      }
    }
  }
`

const Largest = styled.span`
  letter-spacing: normal;
  display: block;
  font-size: 5rem;
  font-size: clamp(5rem, 3.6363636363636367rem + 5.454545454545454vw, 8rem);
  &.longer {
    font-size: 4rem;
    font-size: clamp(4rem, 2.1818181818181817rem + 7.2727272727272725vw, 8rem);
  }
  &.long {
    font-size: 5.2rem;
    font-size: clamp(5.2rem, 3.9272727272727277rem + 5.09090909090909vw, 8rem);
  }
  &.medium {
    font-size: 6rem;
    font-size: clamp(6rem, 5.090909090909091rem + 3.6363636363636362vw, 8rem);
  }
  &.short {
    font-size: 7rem;
    font-size: clamp(7rem, 6.545454545454546rem + 1.8181818181818181vw, 8rem);
  }
`

const MiddlePre = styled.span`
  font-size: 3rem;
  display: block;
  letter-spacing: normal;
  font-size: clamp(3rem, 2rem + 5vw, 6rem);
`

const MiddlePost = styled.span`
  font-size: 3rem;
  display: block;
  letter-spacing: normal;
  font-size: clamp(3rem, 2rem + 5vw, 6rem);
`

const LinkOrText = ({ link, children }) => {
  if (link) {
    return <Link to={link}>{children}</Link>
  }
  return <>{children}</>
}

const PostFormattedTitle = ({
  to,
  title,
  pretitle,
  posttitle,
  largesttitle,
}) => {
  const { pre, middlePre, largestremain, largestformat, middlePost, post } =
    titleHtml(title, pretitle, posttitle, largesttitle)
  return (
    <Title>
      <LinkOrText link={to}>
        {pre && <small className="pretitle">{pre}</small>}
        {middlePre && <MiddlePre>{middlePre}</MiddlePre>}
        {largestformat && (
          <Largest
            className={
              largestformat.length >= 10
                ? 'longer'
                : largestformat.length >= 8
                ? 'long'
                : largestformat.length >= 6
                ? 'medium'
                : largestformat.length < 6
                ? 'short'
                : 'long'
            }>
            {largestformat}
          </Largest>
        )}{' '}
        {largestremain && (
          <Largest
            className={
              largestremain.length >= 10
                ? 'longer'
                : largestremain.length >= 8
                ? 'long'
                : largestremain.length >= 6
                ? 'medium'
                : largestremain.length < 6
                ? 'short'
                : 'long'
            }>
            {largestremain}
          </Largest>
        )}
        {middlePost && <MiddlePost>{middlePost}</MiddlePost>}
        {post && (
          <small
            className={`posttitle ${
              post.length >= 20
                ? 'longer'
                : post.length >= 16
                ? 'long'
                : post.length >= 12
                ? 'medium'
                : post.length < 10
                ? 'short'
                : 'long'
            }`}>
            {post}
          </small>
        )}
      </LinkOrText>
    </Title>
  )
}

const titleHtml = (str, pre, post, largest) => {
  const remaining = str.replace(pre, '').replace(post, '').replace(largest, '')

  const largestWord = remaining.split(' ').reduce((a, b) => {
    return a.length > b.length ? a : b
  })

  const middlePre = remaining.split(largestWord)[0]
  const middlePost = remaining.split(largestWord).pop()
  return {
    pre: pre && str.includes(pre) ? pre : null,
    middlePre: middlePre && middlePre.trim().length > 0 ? middlePre : null,
    largestformat: largest,
    largestremain: largestWord,
    middlePost: middlePost && middlePost.trim().length > 0 ? middlePost : null,
    post: post && str.includes(post) ? post : null,
  }
}

export default PostFormattedTitle
